// tienda/ModalidadesSection.jsx
// Two tier cards: Tienda Estándar and Provider.

import React from "react";
import { motion } from "framer-motion";
import { Store, Package } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";
import { TierCard } from "./TierCard";

export function ModalidadesSection() {
  return (
    <section className="border-b border-slate-100 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2 {...fadeUp} className="text-2xl font-extrabold mb-2" style={{ color: brand.primary }}>
          Dos modalidades, máxima velocidad
        </motion.h2>
        <p className="text-sm text-slate-500 mb-8">Elige según tu volumen y operación.</p>

        <div className="grid gap-4 md:grid-cols-2">
          <TierCard
            icon={<Store className="size-5" />}
            tag="Tienda Estándar"
            tagColor={brand.accentGold}
            title="Recojo desde tu tienda"
            price="S/ 9.90"
            cutoff="Corte 12:00 PM"
            delivery="Entrega mismo día antes de 8 PM"
            perks={[
              "Registra pedidos hasta las 11 AM",
              "Seguimiento en vivo para ti y tu cliente",
              "WhatsApp automático en cada estado",
              "Cobro contraentrega incluido",
            ]}
          />
          <TierCard
            icon={<Package className="size-5" />}
            tag="Provider — Almacén FM"
            tagColor={brand.accentGreen}
            title="Tu stock en nuestro almacén"
            price="S/ 8.90"
            cutoff="Corte 3:00 PM"
            delivery="Vende hasta las 3 PM — entrega el mismo día"
            featured
            perks={[
              "Envía tu stock a nuestro almacén",
              "Cierra ventas hasta las 3:00 PM",
              "Procesamos y despachamos el mismo día",
              "Inventario en tiempo real en tu panel",
              "Tus productos destacados en el marketplace",
            ]}
          />
        </div>
      </div>
    </section>
  );
}